
<template>
  <div id="gallery" class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--fit ">
        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
        <div class="pswp__top-bar" style="top:auto;bottom:0;">
          <div class="pswp__counter" style="font-size:0.32rem;left:50%;width:2rem;margin-left:-0.8rem;text-align:center;"></div>
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>
        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@static/js/util.js';
import * as PhotoSwipeUI_Default from '@static/js/photoswipe/photoswipe-ui-default.js';
import * as PhotoSwipe from '@static/js/photoswipe/photoswipe.js';


export default {
  data () {
    return {
      pswp: null,
      selector: '',
      defaultSelector: '.gallery-item img.pic',
      data: {},
      swipeListener: null, // 滑动监听事件
      fileId: 0 // 图片附件id
    }
  },
  methods: {
    close: function () {
      this.pswp.close();
    },
    initPSWPItems: function () {
      var _this = this;
      _this.data.pwspItems = [];
      _this.data.pwspItemMap = {};
      _this.data.imgArr = [];

      var $imgs = $(_this.selector);
      $imgs.each(function (index) {
        var $img = $(this);
        $img.attr('data-index', index);
        $img.attr('id', 'img_index_' + index);
        _this.data.imgArr.push($img.attr('src'));

        var $p = $img.closest('p');
        if ($p.length > 0 && $.trim($p.text()) == '') {
          $p.css('font-size', '0');
        }
      });
    },
    initGallery: function () {
      var _this = this;
      if (_this.pswp) {
        _this.pswp.close();//禁止重复初始化
      }
      _this.initPSWPItems();
      var initPhotoSwipeFromDOM = function (gallerySelector) {
        var parseThumbnailElements = function (el) {
          var thumbElements = el.childNodes;
          var items = [];
          var width = 0, height = 0;
          var orgWidth = 0, orgHeight = 0;
          var item = {};
          $(_this.selector).each(function (index) {
            var $img = $(this);
            var orgImg = {
              src: $img.attr('src')
            };
            if ($img.attr('data-src')) {
              // orgImg = new Image();
              orgImg.src = $img.attr('data-src');
            }
            if ($img.data('data-object')) {
              orgImg.data = $img.data('data-object')
            }
            var scale = 1;
            if ($img.width() > 0) {
              width = $img.width();
              height = $img.height();
              var wscale = screen.width / width;
              if (wscale > scale) {
                scale = wscale;
              }
            }

            width = parseInt(width * scale, 10);
            height = parseInt(height * scale, 10);
            orgWidth = this.naturalWidth;
            orgHeight = this.naturalHeight;
            // var orgRate = orgHeight / orgWidth

            if (!width || width < 1) {
              width = 320;
              height = 240;
            }

            if (!orgWidth || orgWidth < 1) {
              orgWidth = 1080;
              orgHeight = 800;
            }

            item = {
              src: $img.attr('src'),
              w: parseInt(width, 10),
              h: parseInt(height, 10),
              pid: index
            };

            item.m = {
              src: $img.attr('src'),
              w: parseInt(width, 10),
              h: parseInt(height, 10),
              pid: index
            };

            item.o = {
              src: $img.attr('src'),
              w: orgWidth,
              h: orgHeight,
              pid: index
            };
            // original image
            if (orgImg) {
              item.o = {
                src: orgImg.src,
                w: 1080,
                h: 1080 * orgHeight / orgWidth,
                pid: index,
                data: orgImg.data
              };
            }

            item.msrc = $img.attr('src'); // thumbnail url
            item.el = this; // save link to element for getThumbBoundsFn
            items.push(item);
          });
          return items;
        };

        // find nearest parent element
        var closest = function closest (el, fn) {
          return el && (fn(el) ? el : closest(el.parentNode, fn));
        };
        var onThumbnailsClick = function (e) {
          e = e || window.event;
          e.preventDefault ? e.preventDefault() : e.returnValue = false;
          // 阻止事件冒泡
          e.cancelBubble = true

          var eTarget = e.target || e.srcElement;

          var clickedListItem = closest(eTarget, function (el) {
            return el.tagName === 'p' || el.tagName === 'P' || el.tagName === 'li' || el.tagName === 'LI' || el.tagName === 'div' || el.tagName === 'DIV';
          });

          if (!clickedListItem) {
            return;
          }

          var clickedGallery = clickedListItem;//.parentNode;

          var index = $(this).attr('data-index');
          if (index >= 0) {
            openPhotoSwipe(index, clickedGallery, false, false);
          }

          // $('body').css('overflow','hidden');
          return false;
        };
        var photoswipeParseHash = function () {
          var hash = window.location.hash.substring(1),
            params = {
              gid: 1,
              pid: 1
            };

          if (hash.length < 5) { // pid=1
            return params;
          }

          var vars = hash.split('&');
          for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
              continue;
            }
            var pair = vars[i].split('=');
            if (pair.length < 2) {
              continue;
            }
            params[pair[0]] = pair[1];
          }

          if (params.gid) {
            params.gid = parseInt(params.gid, 10);
          }

          return params;
        };

        var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
          var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;
          items = parseThumbnailElements(galleryElement);

          // define options (if needed)
          options = {
            galleryUID: 1,//galleryElement.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: function (index) {
              // See Options->getThumbBoundsFn section of docs for more info
              // console.log(items[index].el);
              var thumbnail = items[index].el;
              var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();

              return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
            }
          };
          if (fromURL) {
            if (options.galleryUID) {
              // parse real index when custom PIDs are used 
              for (var j = 0; j < items.length; j++) {
                if (items[j].pid == index) {
                  options.index = j;
                  break;
                }
              }
            } else {
              options.index = parseInt(index, 10) - 1;
            }
          } else {
            options.index = parseInt(index, 10);
          }
          options.index = parseInt(index, 10);
          // exit if index not found
          if (isNaN(options.index)) {
            return;
          }
          if (disableAnimation) {
            options.showAnimationDuration = 0;
          }

          options.tapToToggleControls = false;
          options.pinchToClose = false;
          options.tapToClose = true;
          options.galleryPIDs = true;
          options.history = true;
          options.mouseUsed = true;
          options.preload = [1, 0];
          // Pass data to PhotoSwipe and initialize it
          _this.pswp = gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          _this.pswp.listen('close', function () {
            // window.scrollTo(0, 0);
            // window.scrollTo(document.body.scrollWidth,document.body.scrollHeight)
            // _this.$bus.$emit('cropStatus', false);
            // var $img = $('#img_index_' + _this.pswp.getCurrentIndex());
            // // document.body.scrollTop = $img.offset().top;
            // var $img = $('#img_index_' + _this.pswp.getCurrentIndex());
            // if($img.offset().top < document.body.scrollTop || ($img.offset().top > (document.body.scrollTop + screen.height )) ){
            //     document.body.scrollTop = $img.offset().top;	
            // }
            // $('body').css('overflow','auto');
          });

          var realViewportWidth,
            useLargeImages = true,
            firstResize = true,
            imageSrcWillChange;

          gallery.listen('beforeResize', function () {

            var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
            dpiRatio = Math.min(dpiRatio, 2.5);
            realViewportWidth = gallery.viewportSize.x * dpiRatio;

            if (realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200) {
              if (!useLargeImages) {
                useLargeImages = true;
                imageSrcWillChange = true;
              }

            } else {
              if (useLargeImages) {
                useLargeImages = false;
                imageSrcWillChange = true;
              }
            }
            useLargeImages = true;

            if (imageSrcWillChange && !firstResize) {
              gallery.invalidateCurrItems();
            }

            if (firstResize) {
              firstResize = false;
            }
            imageSrcWillChange = false;
          });
          gallery.listen('gettingData', function (index, item) {
            if (useLargeImages) {
              item.src = item.o.src;
              item.w = item.o.w;
              item.h = item.o.h;
            } else {
              item.src = item.m.src;
              item.w = item.m.w;
              item.h = item.m.h;
            }
            // if (item.w < 1 || item.h < 1) { 
            //     var img = new Image(); 
            //     img.onload = function() { 
            //         item.w = this.width; 
            //         item.h = this.height; 
            //         gallery.invalidateCurrItems(); 
            //         gallery.updateSize(true); 
            //         console.log(item);
            //     }
            //     img.src = item.src; 
            // }
          });
          gallery.listen('afterChange', function () {
            if (_this.swipeListener) { // 触发滑动事件
              _this.swipeListener(this.currItem)
            }

            _this.checkStatistic()
            if (this.currItem && this.currItem.o.data) {
              _this.fileId = this.currItem.o.data.id
            }
          });

          gallery.listen('close', function () { // 点击图片退出预览时触发
            _this.checkStatistic()
          });

          gallery.init();
        };

        // select all gallery elements
        var galleryElements = document.querySelectorAll(gallerySelector);
        for (var i = 0, l = galleryElements.length; i < l; i++) {

          galleryElements[i].setAttribute('data-pswp-uid', i + 1);
          galleryElements[i].onclick = onThumbnailsClick;
        }
      };
      initPhotoSwipeFromDOM('.demo-gallery');
    },
    // 判断是否统计预览时长
    checkStatistic () {
      if (this.fileId > 0) {
        if (this.swipeListener) { // 有监听器的情况下说明需要做统计，此时才需要发送关闭指令
          this.sendCloseCmd()
        }
        this.fileId = 0
      }
    },
    // 发送停止预览指令
    sendCloseCmd () {
      this.$bus.$emit('stopPreview', {
        id: this.fileId,
        isStop: true
      })
    },
    init: function (selector) {
      var _this = this;
      _this.swipeListener = null
      _this.selector = selector;
      if (!_this.selector) {
        _this.selector = _this.defaultSelector;
      }
      console.log('gallery init');
      // weui.toast('gallery init')
      // setTimeout(function(){
      $('body').find(_this.selector).addClass('demo-gallery');//图集预览
      _this.initGallery();
      // }, 100);//.1s延迟用于vue的加载

      $('#gallery').on('touchmove', '.pswp__scroll-wrap', function () {
        // weui.toast('touchmove');
      })
    },
    initBySwipe (func) {
      this.init()
      this.swipeListener = func
    },
    created () {
      console.log('gallery created')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/plugins/gallery.vue